import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsSearchState } from '../reducers/search-literals.reducer';
import * as selectors from '../selectors/search-literals.selectors';

@Injectable({ providedIn: 'root' })
export class LiteralsSearchFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsSearchState>) {
    super(store);
  }

  // OBSERVABLES

  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  literalCode$ = this.storeSelect(selectors.getLiteralCode);
  literalText$ = this.storeSelect(selectors.getLiteralText);
  availableLanguages$ = this.storeSelect(selectors.getAvailableLanguages);
  selectedLanguage$ = this.storeSelect(selectors.getSelectedLanguage);
  literals$ = this.storeSelect(selectors.getLiterals);

  // OBSERVABLE'S VALUES

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get literalCode() {
    return this.storeSnapshot(this.literalCode$);
  }

  get literalText() {
    return this.storeSnapshot(this.literalText$);
  }

  get availableLanguages() {
    return this.storeSnapshot(this.availableLanguages$);
  }

  get selectedLanguage() {
    return this.storeSnapshot(this.selectedLanguage$);
  }

  get literals() {
    return this.storeSnapshot(this.literals$);
  }
}
